<div class="input-group">
	<button (click)="_show = !_show; clickedInside($event)" class="btn btn-outline-duo ms-2 dropdown-toggle">
		{{ title || 'More Actions' }}
	</button>

	<ul class="dropdown-menu dropdown-menu-end" [class.show]="_show" [ngClass]="position">
		<ng-content></ng-content>
	</ul>
</div>
